import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import PartnerWithProspect from "./sections/PartnerWithProspect";
import InTheNeighborhood from "./sections/InTheNeighborhood";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <PartnerWithProspect />
      <InTheNeighborhood />
      <Footer />
    </div>;
}